var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddTableDataIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#0176BC",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 3,
    fill: "#0176BC",
    stroke: "#0176BC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 3.5,
    width: 15,
    height: 5,
    stroke: "#0277BD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 13,
    stroke: "#0277BD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 5,
    height: 13,
    stroke: "#0277BD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 0.5,
    width: 5,
    height: 13,
    stroke: "#0277BD"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF",
    stroke: "#0176BC",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 12.5,
    r: 4.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 12.8571H14.8571V15H14.1429V12.8571H12V12.1429H14.1429V10H14.8571V12.1429H17V12.8571Z",
    fill: "#0176BC"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddTableDataIcon);
export default __webpack_public_path__ + "static/media/AddTableDataIcon.576c4302.svg";
export { ForwardRef as ReactComponent };